import React from "react";
import { formatTimeAgo, toFullWidthNumber, getMarkdownExcerpt, parseTags } from "../../../utils/format";
import CustomIconButton from "../../../components/CustomIconButton";

type NewsCardProps = {
    items: any;
    goToDetail?: (id: number) => void;
    handleBookmark?: (id: number) => void;
    customStyle: any;
    hideBookmark: boolean;
    line_option: string;
};

const NewsCard = ({ items, goToDetail, handleBookmark, customStyle="", hideBookmark=false, line_option="line-clamp-3" }: NewsCardProps) => {
    const item = {
        ...items,
        tags: items?.tags ? parseTags(String(items.tags)) : "",
    }
    const titleLines = parseInt(line_option.split("-")[2]);

    return (
        <>
        <div className={`relative rounded-t-lg md:rounded-t-2xl rounded-b-[0.25rem] md:rounded-b-none aspect-video ${customStyle}`}>
            <img
                onClick={() => goToDetail(item.id)}
                src={item.images}
                alt={item.title}
                className="w-full h-full object-contain rounded-t-lg md:rounded-2xl rounded-b-[0.25rem] md:rounded-b-none group-hover:opacity-80 group-hover:cursor-pointer aspect-video"
            />
        </div>

        <div className="p-4 flex-1 flex flex-col justify-between w-full">
            <h5
                onClick={() => goToDetail(item.id)}
                className={`mb-2 md:mb-4 text-base alu-text-base-2 font-bold cursor-pointer group-hover:underline underline-offset-1 break-words break-all ${line_option}`}
            >
                {item.title}
            </h5>
            <div className="flex-1 flex flex-col justify-between">
                <p className="mb-2 text-sm alu-text-base-2 line-clamp-2 whitespace-pre-wrap break-words break-all">
                    {getMarkdownExcerpt(item.contents)}
                </p>
                <div className="flex flex-col justify-between">
                    <div className="flex items-center justify-between gap-8 mb-1">
                        <div className="flex-1 flex items-center gap-6 text-sm alu-text-base-1">
                            <p className="text-sm leading-[1.3125rem] alu-text-base-1">{item?.news_type_display?.name}</p>
                            <p className="text-sm leading-[1.3125rem] alu-text-base-1">{toFullWidthNumber(formatTimeAgo(item.public_date))}</p>
                        </div>
                        {!hideBookmark && (
                        <CustomIconButton 
                            onClick={() => handleBookmark(item.id)}
                            customStyle="shrink-0 group/bookmark"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_11236_7241)">
                                <path
                                    d={!item.is_bookmarked ? "M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z" : "M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"}
                                    fill={!item.is_bookmarked ? "#808080" : "#FF861A"}
                                    className={!item.is_bookmarked ? "group-hover/bookmark:fill-[#FF861A] transition-colors duration-100 ease-in-out" : ""}
                                />
                                </g>
                                <defs>
                                <clipPath id="clip0_11236_7241">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </CustomIconButton>
                        )}
                    </div>
                    {/* min-h-[21px] ensures that every card will have the minimal height of tags field (laptop's view) */}
                    <p className="text-sm leading-[1.3125rem] alu-text-base-1 md:min-h-[21px]">
                        {item?.tags && item?.tags.map((tag: string, index: number) => (
                            <span key={index} className="mr-1">#{tag.trim()}{index < item?.tags.length - 1 && ','}</span>
                        ))}
                    </p>
                </div>
            </div>
        </div>
        </>
    );
};

export default NewsCard;
